import { _isEmptyString, _isNil } from '@/littledash';

/**
 * Converts an unknown value to a finite number, or `null` when it has no numeric meaning.
 *
 * Blank strings are treated as `null` rather than `0` — `Number('')` evaluates to `0`, which would
 * otherwise make a cleared numeric input render a value the user cannot delete.
 */
export const toFiniteNumberOrNull = (value: unknown): number | null => {
  if (_isNil(value) || _isEmptyString(value)) {
    return null;
  }

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};
